import React from 'react';
import { motion } from 'framer-motion';
import './About.scss';
import images from '../../constants/images';
import AppWrap from '../../wrapper/AppWrap';

const About = () => {
  const handleDownloadResume = () => {
    // Replace this URL with your actual resume file path or direct link
    const resumeUrl = images.Ayuscal_Sedhai_Resume;
    const link = document.createElement('a');
    link.href = resumeUrl;
    link.download = 'ayuscal-resume.pdf';
    link.target = '_blank'; // Opens in new tab if it's a Google Drive link
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <section>
      <div className="app__about" style={{ paddingTop: '0px' }}>
        <motion.h2
          className="head-text"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          About <span className="text-blue-600">Me</span>
        </motion.h2>

        <motion.div
          className="app__about-content"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          style={{
            maxWidth: '900px',
            margin: '0 auto',
            textAlign: 'center',
            padding: '2rem'
          }}
        >
          <p className="p-text" style={{ marginBottom: '1.5rem', lineHeight: '1.8', fontSize: '1.2rem',textAlign: 'justify' }}>
            Hi! I'm <strong>Ayuscal Sedhai</strong>, a passionate and self-driven tech enthusiast from Nepal. 
            I love building practical solutions that make real-world tasks easier, smarter, and more efficient. 
            I enjoy working across <strong>Web Development</strong>, <strong>Artificial Intelligence</strong>, 
            <strong> Machine Learning</strong>, <strong>Data Analysis</strong>, and <strong>Business Intelligence</strong>, 
            and I'm always exploring new tools and technologies to improve my skills.
          </p>

          <p className="p-text" style={{ marginBottom: '1.5rem', lineHeight: '1.8', fontSize: '1.2rem',textAlign: 'justify' }}>
            I've worked on several impactful academic and personal projects, including online voting systems, 
            data analysis dashboards, ML-powered applications, and BI-based reports. I also work actively with 
            tools like <strong>Power BI</strong>, <strong>SQL</strong>, <strong>Python</strong>, <strong>Java</strong>, 
            and cloud-based analytics platforms.
          </p>

          <p className="p-text" style={{ marginBottom: '1.5rem', lineHeight: '1.8', fontSize: '1.2rem',textAlign: 'justify' }}>
            Beyond coding, I enjoy learning about business systems, ERP workflows, and IT entrepreneurship, 
            and I'm exploring how to build impactful tech products in Nepal.
          </p>

          <p className="p-text" style={{ marginBottom: '2.5rem', lineHeight: '1.8', fontSize: '1.2rem',textAlign: 'justify' }}>
            I believe in <strong>continuous learning</strong>, <strong>clean problem-solving</strong>, 
            and creating solutions that combine creativity with technology.
          </p>

          <motion.button
            className="resume-button"
            onClick={handleDownloadResume}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            style={{
              padding: '1rem 2.5rem',
              fontSize: '1.1rem',
              fontWeight: 'bold',
              color: '#fff',
              background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)',
              border: 'none',
              borderRadius: '50px',
              cursor: 'pointer',
              boxShadow: '0 4px 15px rgba(37, 99, 235, 0.3)',
              transition: 'all 0.3s ease'
            }}
          >
            Download Resume
          </motion.button>
        </motion.div>
      </div>
    </section>
  );
};

export default AppWrap(About, 'about');